import React from 'react';
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
	from { top: -60px; }
	to   { top: 12px; }
`;

const fadeOut = keyframes`
	from { top: 12px; }
	to   { top: -60px; }
`;

const Wrapper = styled.div`
	position: fixed;
	top: 12px;
	left: 2%;
	width: 96%;
	display: grid;
	grid-template-columns: 4px auto;
	gap: 0px;
	margin: 0px;
	animation: ${props => props.show ? `${fadeIn} 0.5s ease-in-out` : `${fadeOut} 0.5s ease-in-out`};
	z-index: 1;
`;

const Emphasis = styled.div`
	width: 4px;
	height: 100%;
	background: #00529B;
	border-radius: 4px 0px 0px 4px;
`;

const Content = styled.div`
	background: #F2F7F9;
	padding: 11px 12px;
	border: 1px solid #E5EDF5;
	border-left: none;
	border-radius: 0px 4px 4px 0px;
	display: flex;
	align-items: center;
	font-family: 'AMX-Bold';
	font-size: 14px;
	color: #222222;
`;

const Icon = styled.img`
	width: 24px; 
	margin-right: 16px;
`;

const Text = styled.span`
	position: relative;
	top: 2px
`;

const Snackbar = (props) => {
	const [fadeOut, setFadeOut] = React.useState(false);
	const SNACKBAR_TIME_VISIBLE = 10000;
	const SNACKBAR_TIME_EFFECT = 500;

	React.useEffect(() => {
		if (props.isOpenCompleteInformationSnackBar) {
			// Send taggeo
			const { services } = props.selectPaymentServiceConf;
			const serviceName = 
				services && 
				services[0] && 
				services[0].serviceData &&
				services[0].serviceData.info
					? services[0].serviceData.info.serviceName
					: "";
			props.executeTaggeo({
				eventName: "pay_service_or_tae",
				step: "Formulario de pago",
				action: "View snackbar Completa la información",
				service: serviceName
			});

			// Set time that will be visible
			const timer = setTimeout(() => {
				setFadeOut(true);
			}, SNACKBAR_TIME_VISIBLE);
	
			// Set effect time
			const fadeOutTimer = setTimeout(() => {
				props.handleIsOpenCompleteInformationSnackBar(false);
			}, SNACKBAR_TIME_VISIBLE + SNACKBAR_TIME_EFFECT);
	
			return () => {
				clearTimeout(timer);
				clearTimeout(fadeOutTimer);
			};
		}		
	}, [props.isOpenCompleteInformationSnackBar]);
	
	return (
		<>
			{props.isOpenCompleteInformationSnackBar && (
				<Wrapper show={!fadeOut}>
					<Emphasis />
					<Content>
						<Icon src={props.message.data.icon} />
						<Text>{props.message.data.subject}</Text>
					</Content>
				</Wrapper>
			)}
		</>
	)
}

export default Snackbar
